export default __webpack_public_path__ + "static/media/medium.fcad930b.png";